import _styled, { css as _css, default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import Marquee from "react-fast-marquee";
import Cookies from "js-cookie";
import { debounce } from "~/features/app/utils";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import { RichText } from "~/features/ui/rich-text";
import { Icon } from "~/features/ui/icon";
import Close from "~/public/icons/close.svg";
type Props = {
  text: string;
};
const COOKIE_KEY = "ouster-announcement-viewed";
export function AnnouncementBar(props: Props) {
  const {
    text
  } = props;
  const {
    isAnnouncementBarVisible,
    setIsAnnouncementBarVisible
  } = useNavLayout();
  const [playMarquee, setPlayMarquee] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);
  const [isClient, setIsClient] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    setIsClient(true);
  }, []);
  React.useEffect(() => {
    const cookie = Cookies.get(COOKIE_KEY);
    if (cookie) {
      setIsAnnouncementBarVisible(false);
    } else {
      setIsAnnouncementBarVisible(true);
    }
    if (!isReady) {
      return;
    }
    function onResize() {
      if (!ref.current) {
        return;
      }
      const viewportWidth = window.innerWidth;
      setPlayMarquee(ref.current.clientWidth > viewportWidth - 48);
    }
    const debouncedOnResize = debounce(onResize);
    onResize();
    window.addEventListener("resize", debouncedOnResize);
    return () => {
      window.removeEventListener("resize", debouncedOnResize);
    };
  }, [isReady, setIsAnnouncementBarVisible]);
  if (!isClient || !isAnnouncementBarVisible) {
    return null;
  }
  function onDismiss() {
    setIsAnnouncementBarVisible(false);
    Cookies.set(COOKIE_KEY, "true", {
      expires: 1
    });
  }
  return <_StyledDiv>
      <_StyledMarquee play={playMarquee} key={String(playMarquee)} onMount={() => setIsReady(true)} speed={20} autoFill={playMarquee} gradient gradientColor="rgb(75, 46, 248)" gradientWidth={20}>
        <_StyledDiv2 ref={ref}>
          <_StyledRichText text={text} $_css2={_css(["", " a{", "}"], {
          "whiteSpace": "nowrap",
          "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
          "fontSize": "1.2rem",
          "lineHeight": "1.1",
          "letterSpacing": "0.024rem",
          "fontWeight": "400",
          "@media (min-width: 1024px)": {
            "fontSize": "1.4rem",
            "lineHeight": "1.1",
            "letterSpacing": "0.028000000000000004rem",
            "fontWeight": "400"
          }
        }, {
          "--tw-text-opacity": "1 !important",
          "color": "rgb(255 255 255 / var(--tw-text-opacity)) !important"
        })} />
        </_StyledDiv2>
      </_StyledMarquee>
      <_StyledButton onClick={onDismiss} aria-label="Dismiss announcement">
        <Icon icon={Close} />
      </_StyledButton>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-uszm5-0"
})({
  "position": "absolute",
  "left": "0",
  "right": "0",
  "top": "0",
  "zIndex": "110",
  "display": "flex",
  "height": "var(--announcement-bar-height)",
  "alignItems": "center",
  "justifyContent": "space-between",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-divide-x-reverse": "0",
    "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
    "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))",
    "borderColor": "rgba(255, 255, 255, 0.3)"
  },
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
var _StyledMarquee = _styled2(Marquee).withConfig({
  componentId: "sc-sf-uszm5-1"
})({
  "height": "100%"
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-uszm5-2"
})({
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
});
var _StyledRichText = _styled4(RichText).withConfig({
  componentId: "sc-sf-uszm5-3"
})`${p => p.$_css2}`;
var _StyledButton = /*#__PURE__*/_styled5("button").withConfig({
  displayName: "announcement-bar___StyledButton",
  componentId: "sc-15dxx6r-0"
})({
  "display": "flex",
  "height": "var(--announcement-bar-height)",
  "width": "var(--announcement-bar-height)",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center"
});